import { forwardRef } from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_sports-psych-assess/artifacts/c5xfaumz_Godspeed%20Logo%20Original%20-%20Maroon%20Final.png";

const CAT_COLORS = {
  Focus: "#1C3F39",
  Resilience: "#E25F38",
  Confidence: "#345E5C",
  Motivation: "#D9A05B",
  "Anxiety Management": "#9CAE96",
};

// A 1080x1350 (4:5) social-friendly card.
// forwardRef so parent can capture it with html-to-image.
const ShareCard = forwardRef(function ShareCard({ result }, ref) {
  return (
    <div
      ref={ref}
      data-testid="share-card"
      style={{
        width: 1080,
        height: 1350,
        background: "#F7F7F5",
        fontFamily: "Manrope, sans-serif",
        color: "#111827",
        padding: 72,
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Watermark - centered, low opacity */}
      <img
        src={LOGO_URL}
        alt=""
        crossOrigin="anonymous"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 720,
          opacity: 0.06,
          pointerEvents: "none",
        }}
      />

      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        <img
          src={LOGO_URL}
          alt="Godspeed Sports"
          crossOrigin="anonymous"
          style={{
            width: 160,
            height: 96,
            objectFit: "contain",
            background: "#000",
            borderRadius: 8,
          }}
        />
        <div style={{ textAlign: "right" }}>
          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              letterSpacing: "0.22em",
              textTransform: "uppercase",
              color: "#E25F38",
              marginBottom: 6,
            }}
          >
            Mental Performance Card
          </div>
          <div style={{ fontSize: 16, color: "#4B5563" }}>{result.sport}</div>
        </div>
      </div>

      {/* Athlete name */}
      <div style={{ marginTop: 48, position: "relative", zIndex: 1 }}>
        <div
          style={{
            fontSize: 14,
            fontWeight: 700,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: "#4B5563",
            marginBottom: 12,
          }}
        >
          Athlete
        </div>
        <div
          style={{
            fontSize: 72,
            fontFamily: "'Cabinet Grotesk', Manrope, sans-serif",
            fontWeight: 900,
            letterSpacing: "-0.02em",
            lineHeight: 1,
          }}
        >
          {result.name}
        </div>
      </div>

      {/* Big score */}
      <div
        style={{
          marginTop: 64,
          background: "#fff",
          border: "2px solid #1C3F39",
          borderRadius: 16,
          padding: 48,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div>
          <div
            style={{
              fontSize: 14,
              fontWeight: 700,
              letterSpacing: "0.22em",
              textTransform: "uppercase",
              color: "#4B5563",
              marginBottom: 8,
            }}
          >
            Overall Score
          </div>
          <div
            style={{
              fontFamily: "'Cabinet Grotesk', Manrope, sans-serif",
              fontWeight: 900,
              fontSize: 180,
              lineHeight: 0.9,
              color: "#1C3F39",
              letterSpacing: "-0.04em",
            }}
          >
            {result.overall_score}
            <span style={{ fontSize: 80, color: "#4B5563" }}>%</span>
          </div>
        </div>
        <div
          style={{
            padding: "16px 28px",
            background: "#1C3F39",
            color: "#fff",
            fontSize: 18,
            fontWeight: 800,
            letterSpacing: "0.18em",
            textTransform: "uppercase",
            borderRadius: 999,
          }}
        >
          {result.overall_label}
        </div>
      </div>

      {/* Category bars */}
      <div
        style={{
          marginTop: 40,
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: 16,
          padding: 36,
          position: "relative",
          zIndex: 1,
          flex: 1,
        }}
      >
        <div
          style={{
            fontSize: 14,
            fontWeight: 700,
            letterSpacing: "0.22em",
            textTransform: "uppercase",
            color: "#4B5563",
            marginBottom: 20,
          }}
        >
          Category Breakdown
        </div>
        {result.categories.map((c) => (
          <div key={c.key} style={{ marginBottom: 18 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 6,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: 999,
                    background: CAT_COLORS[c.label],
                    display: "inline-block",
                  }}
                />
                <span style={{ fontSize: 22, fontWeight: 700 }}>{c.label}</span>
              </div>
              <span
                style={{
                  fontSize: 22,
                  fontWeight: 800,
                  color: "#1C3F39",
                }}
              >
                {c.percentage}%
              </span>
            </div>
            <div
              style={{
                height: 10,
                background: "#F7F7F5",
                borderRadius: 999,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  width: `${c.percentage}%`,
                  height: "100%",
                  background: CAT_COLORS[c.label],
                  borderRadius: 999,
                }}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Footer */}
      <div
        style={{
          marginTop: 32,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          style={{
            fontFamily: "'Cabinet Grotesk', Manrope, sans-serif",
            fontWeight: 900,
            fontSize: 28,
            color: "#1C3F39",
          }}
        >
          Godspeed Sports
        </div>
        <div
          style={{
            fontSize: 16,
            color: "#4B5563",
            fontWeight: 600,
          }}
        >
          Train the mind. Win the moment.
        </div>
      </div>
    </div>
  );
});

export default ShareCard;
